import { Api } from '@axiom/ui';
import type { Permissions } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class PermissionsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  readPermissions(candidateId: string) {
    return super.read<{ data: Permissions }>({
      endpoint: `/saml/permissions/${candidateId}`,
      method: 'GET',
    });
  }
}

export const PermissionsApi = new PermissionsApiClass();
